module.exports = __webpack_public_path__ + "img/bp_title2.9470a520.png";